<template>
  <div>
    <video-gallery :videos='videos' v-on='$listeners' />
    <infinite-loading @infinite="onLoadMore" />
    <div class="h-24" />
  </div>
</template>
<script>
import VideoGallery from '@ui/molecules/VideoGallery.vue';
export default {
  props: {
    videos: {
      type: Array,
      required: true
    },
    loadMore: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      busy: true
    }
  },
  components: {
    VideoGallery
  },
  methods: {
    async onLoadMore($state) {
      const remaining = await this.loadMore();
      if (remaining > 0) {
        $state.loaded();
      } else {
        $state.complete();
      }
    }
  }

}
</script>

